module.exports = __webpack_public_path__ + "static/strength_plans_mobile-38079bbe00bb2f31b719e8bf7bede744.jpg";